import { QueryKey } from "@tanstack/react-query";

export const zapierQueryKeys = {
  all: () => ["zapier"] as QueryKey,
  getIntegrationStatus: (clubId: number) =>
    [...zapierQueryKeys.all(), clubId, "getIntegrationStatus"] as QueryKey,
  getIntegrationConfig: (clubId: number) =>
    [...zapierQueryKeys.all(), clubId, "getIntegrationConfig"] as QueryKey,
};
